import { useEffect, useState } from "react";

// True whenever the tab is hidden or the window loses focus — a strong signal
// that a screenshot / screen-share / app-switch may be happening.
export function useDefocusHidden() {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const onVis = () => setHidden(document.hidden);
    const onBlur = () => setHidden(true);
    const onFocus = () => setHidden(document.hidden);
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("blur", onBlur);
    window.addEventListener("focus", onFocus);
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("focus", onFocus);
    };
  }, []);
  return hidden;
}

// Best-effort screenshot-key detection (PrintScreen, macOS ⌘⇧3/4/5).
// Web browsers cannot truly block OS screenshots — this is a deterrent that
// also clears the clipboard when possible.
export function useScreenshotKey(onDetect) {
  useEffect(() => {
    const handler = (e) => {
      const mac = e.metaKey && e.shiftKey && ["3", "4", "5"].includes(e.key);
      if (e.key === "PrintScreen" || mac) {
        try { navigator.clipboard?.writeText(" "); } catch { /* ignore */ }
        onDetect?.();
      }
    };
    window.addEventListener("keyup", handler);
    return () => window.removeEventListener("keyup", handler);
  }, [onDetect]);
}
